import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import Box from "../components/Box";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoadingProgress from "../components/LoadingProgress";

import { fetchMatrixs } from "../actions/matrixs";
import { getLockersName } from "../utils/machines";
import ErrorMessage from "../components/ErrorMessage";
import {
  postBooking,
  postPrebooking,
  postCancelPrebooking,
  fetchCustomer,
} from "../actions/qrs";
import { postPDAsale, fetchPDACustomer } from "../actions/pdas";
import StepBar from "../components/StepBar";
import { fetchSaleTicket } from "../actions/sales";
import { postCounterInvoicePDASale } from "../actions/pdas";
import "../styles/LockerSaleView.css";

class LockerSaleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingInProgress: false,
      phoneValue: "",
      zoneSelected: 0,
      lockerSelected: "",
      lockerResult: 0,
      lockerType: "",
      lockerPass: "000000",
      machineResult: "XXXX",
      machineFirstIndex: 0,
      lockerAssigned: false,
      prebooking: false,
      lockerPin: "",
      lockerMatricula: 0,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      booked: false,
      lockerPrice: 0,
      stepBarStep: 1,
      invoice: "00000000",
      time: "",
      customer: "",
      cif: "",
      address: "",
      phoneDuplicate: false,
      choiceMade: 0,
      ticketInvoice: "",
      saleData: null,
      counterInvoiceData: null,
      fetchingSale: false,
      saleNotFound: false,
      confirmationStep: 0,
      devolutionMethod: null,
    };
  }

  componentDidMount() {
    // this.props.fetchMatrixs('', ''),

    this.props
      .fetchCustomer(this.props.id)
      .then((answer) => {
        if (answer.response.Customer) {
          this.props.fetchPDACustomer(answer.response.Customer);

          this.props
            .fetchCustomer(answer.response.Customer)
            .then((answer) => {
              this.setState({
                customer: answer.response.Social_name,
                cif: answer.response.Invoice_taxid,
                address: answer.response.Invoice_address,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.setState({
            customer: answer.response.Social_name,
            cif: answer.response.Invoice_taxid,
            address: answer.response.Invoice_address,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {
    this.resetProcess();
  }

  fetchSaleTicket = () => {
    const { ticketInvoice } = this.state;

    this.setState({ fetchingSale: true, saleNotFound: false });

    this.props
      .fetchSaleTicket(ticketInvoice)
      .then((answer) => {
        if (answer && answer.response) {
          this.setState({
            saleData: answer.response,
            fetchingSale: false,
            confirmationStep: 1,
          });
        } else {
          this.setState({
            fetchingSale: false,
            saleNotFound: true,
          });
        }
      })
      .catch(() => {
        this.setState({
          fetchingSale: false,
          saleNotFound: true,
        });
      });
  };

  generateCounterInvoice = () => {
    const { ticketInvoice, devolutionMethod } = this.state;

    this.props
      .postCounterInvoicePDASale(ticketInvoice, devolutionMethod)
      .then((answer) => {
        this.setState({
          counterInvoiceData: answer.response,
          confirmationStep: 2,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleRedirect = () => {
    this.resetProcess();
  };

  handleInvoiceInput = (e) => {
    this.setState({ ticketInvoice: e.target.value });
  };

  handleDevolutionMethodInput = (e) => {
    this.setState({ devolutionMethod: e.target.value });
  };

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState((prevState) => ({ seconds: prevState.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState((prevState) => ({
            minutes: prevState.minutes - 1,
            seconds: 59,
          }));
        } else {
          clearInterval(this.countdownInterval);
          // Here you can add any logic you want to perform after the countdown reaches 0
          this.setState({ isTimeUp: true });
        }
      }
    }, 1000);
  };

  printLockerTicket(e, printIndex) {
    const content = document.getElementById(`${printIndex}`).innerHTML;
    const printWindow = window.open("", "", "height=400,width=600");
    printWindow.document.write("<html><head><title>PIN TICKET</title>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(content);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  }

  getLockerPcPicture(type) {
    return `/images/measures/locker_${type}.png`;
  }

  renderChoice() {
    const { customer, error } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer) {
      return <LoadingProgress />;
    }

    return (
      <>
        <div
          className="ls-choice-card"
          onClick={() => this.setState({ choiceMade: 1 })}
        >
          <div className="ls-choice-icon ls-choice-sell">
            <i className="fas fa-tag"></i>
          </div>
          <h2 className="ls-choice-title">Vender Taquilla</h2>
          <img
            src="/images/lockersale.png"
            alt="Rent Locker"
            className="ls-choice-img"
          />
        </div>
        <div
          className="ls-choice-card"
          onClick={() => this.setState({ choiceMade: 2 })}
        >
          <div className="ls-choice-icon ls-choice-return">
            <i className="fas fa-undo-alt"></i>
          </div>
          <h2 className="ls-choice-title">Devolver Taquilla</h2>
          <img
            src="/images/counterlockersale.png"
            alt="Return Locker"
            className="ls-choice-img"
          />
        </div>
      </>
    );
  }

  renderZones() {
    const { customer, error, category } = this.props;

    const zonesRow = [];

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer) {
      return <LoadingProgress />;
    }

    if (customer.Zones) {
      customer.Zones.filter((zone) =>
        category === "BAQUEIRA" ? zone.Zone === 6 : true,
      ).map((zone, index) => {
        zonesRow.push(
          <div
            key={zone.Zone}
            className={
              this.state.zoneSelected === zone.Zone ? "cubeselected" : "cube"
            }
            onClick={(e) => {
              (this.setState({
                zoneSelected: zone.Zone,
                lockerAssigned: false,
                lockerSelected: "",
                phoneValue: "",
                stepBarStep: 2,
              }),
                this.props.fetchMatrixs("", "", customer._id, zone.Zone));
            }}
          >
            <img
              src="/images/Ping.svg"
              alt={"Ping " + zone}
              className="pingImage"
            />
            <h5>{`Zona ${zone.Zone}`}</h5>
            <hr className="bg-vw-light" />
            <h5>{zone.Description}</h5>
          </div>,
        );
      });
    } else {
      this.setState({
        zoneSelected: 0,
        lockerAssigned: false,
        lockerSelected: "",
        phoneValue: "",
        stepBarStep: 2,
      });
      this.props.fetchMatrixs("", "", customer._id, "");
    }

    return zonesRow;
  }

  renderLockers() {
    const { pda, matrixs, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!pda || !matrixs || loading) {
      return (
        <div>
          <LoadingProgress />
          <h5>Esperando Zona...</h5>
        </div>
      );
    }

    // Ordered list of locker keys
    const orderedLockerKeys = [
      "LOCKERBNS",
      "LOCKERCNS",
      "LOCKERBWS",
      "LOCKERCWS",
      "LOCKERBNM",
      "LOCKERCNM",
      "LOCKERBWM",
      "LOCKERCWM",
      "LOCKERBNL",
      "LOCKERCNL",
      "LOCKERBWL",
      "LOCKERCWL",
      "LOCKERBNXL",
      "LOCKERCNXL",
      "LOCKERBWXL",
      "LOCKERCWXL",
      "LOCKERBN2XL",
      "LOCKERCN2XL",
      "LOCKERBW2XL",
      "LOCKERCW2XL",
      "LOCKERBN3XL",
      "LOCKERCN3XL",
      "LOCKERBW3XL",
      "LOCKERCW3XL",
    ];

    // Collect available lockers into a Set
    const availableLockers = new Set();

    matrixs.forEach((matrix) => {
      matrix.Locker.forEach((lock) => {
        if (lock.Configured && lock.Status === "BL") {
          availableLockers.add(`LOCKER${lock.Mode}${lock.Wide}${lock.Type}`);
        }
      });
    });

    // Render in correct order
    const lockersRow = orderedLockerKeys
      .filter((lockerKey) => availableLockers.has(lockerKey))
      .map((lockerKey) => {
        const lockerName = getLockersName(lockerKey);
        const lockerItem = (pda.Items || []).find(
          (item) => item.item === lockerKey,
        );

        return (
          <div
            key={lockerKey}
            className={
              this.state.lockerSelected === lockerKey.slice(6)
                ? "cubeselected"
                : "cube"
            }
            onClick={() => {
              this.prebookLocker(
                lockerKey.slice(6),
                lockerItem ? lockerItem.price : 0,
              );
            }}
          >
            <h5>{lockerName}</h5>
            <div className="cube-price text-white mb-3">
              {lockerItem ? lockerItem.price.toFixed(2) + "€" : "N/A"}
            </div>
            <div id={`locker${lockerKey.slice(6)}`}>
              <p></p>
              <div id="AV">
                <p></p>
              </div>
            </div>
          </div>
        );
      });

    if (lockersRow.length === 0) {
      return (
        <div className="p-5">
          <h5>Lamentamos informarte que no quedan taquillas disponibles</h5>
        </div>
      );
    }

    return lockersRow;
  }

  renderPhone() {
    const { minutes, seconds } = this.state;

    return (
      <div className="input-container text-center">
        <p>
          Hemos reservado una taquilla, introduce un teléfono de respaldo y
          asigna la taquilla dentro del tiempo marcado
        </p>
        <input
          className="full mt-2 mb-2"
          placeholder="Introduce un teléfono"
          type="number"
          value={this.state.phoneValue}
          onChange={(e) => {
            const inputPhone = e.target.value;
            const { lockerPhones = [] } = this.state;

            const isDuplicate = lockerPhones.includes(inputPhone.trim());

            this.setState({
              phoneValue: inputPhone,
              phoneDuplicate: isDuplicate,
            });
          }}
        />
        {this.state.phoneDuplicate && (
          <p className="text-danger">
            Este teléfono ya está registrado en otra taquilla.
          </p>
        )}
        <div className="countdownTPV">
          <p>Tiempo para confirmar</p>
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>
      </div>
    );
  }

  renderDevolution() {
    const {
      fetchingSale,
      saleNotFound,
      saleData,
      counterInvoiceData,
      confirmationStep,
      devolutionMethod,
    } = this.state;
    const { pda } = this.props;

    if (confirmationStep === 0) {
      return (
        <div className="input-container text-center mt-5">
          <p>Introduce el código de factura del ticket original:</p>
          <input
            className="full mt-2 mb-2"
            placeholder="Número de factura"
            type="text"
            value={this.state.ticketInvoice}
            onChange={this.handleInvoiceInput}
          />
          <button
            className="btn bg-primary text-white"
            onClick={this.fetchSaleTicket}
            disabled={fetchingSale || !this.state.ticketInvoice}
          >
            Consultar Ticket
          </button>

          {fetchingSale && <p className="mt-2">Buscando ticket...</p>}
          {saleNotFound && (
            <p className="text-danger mt-2">Factura no encontrada.</p>
          )}
        </div>
      );
    }

    if (confirmationStep === 1 && saleData) {
      const itemName = getLockersName(saleData.Items[0].item);

      return (
        <div className="row">
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="lockerTicket mt-5">
              <h1 className="lockTitle">
                <span>FACTURA ORIGINAL</span>
              </h1>
              <hr className="bg-vw-light" />
              <h5 className="lockTitle">
                <span className="text-vw-dark">TAQUILLA</span>
              </h5>
              <h1 className="lockTitle">
                <span>{saleData.Locker}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">TIPO</span>
              </h5>
              <h1 className="lockTitle">
                <span>{itemName}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">PAGADO CON</span>
              </h5>
              <h1 className="lockTitle">
                <span>{saleData.PaymentMethod}</span>
              </h1>

              <hr className="bg-vw-light" />
              <br />

              <h5 className="lockTitle">
                <span>{saleData.Customer.Fullname}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">Terminal:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{saleData.Code.slice(0, -6)}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura simplificada:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{saleData.Code}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Fecha/Hora:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{new Date(saleData.TimeStamp).toLocaleString()}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">PRODUCTOS</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>
                  {saleData.Items[0].qty}x {itemName}
                </span>
                <span>{saleData.Amount.toFixed(2)}€</span>
              </h5>
              <br />

              <h5 className="lockTitleJustify">
                <span>MONEDA:</span>
                <span>EUR</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>BASE:</span>
                <span>{this.getBase(saleData.Amount).toFixed(2)}€</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>IVA:</span>
                <span>{this.getIva(saleData.Amount).toFixed(2)}€</span>
              </h5>

              <h5 className="lockTitle">
                <span>-----------------</span>
              </h5>

              <h5 className="lockTitleJustify">
                <span>TOTAL:</span>
                <span>{saleData.Amount.toFixed(2)}€</span>
              </h5>
              <br />
              <hr className="bg-vw-light" />
            </div>
          </div>
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="mt-5 text-center">
              <p>¡ADVERTENCIA!</p>
              <p>
                Esta operativa NO DEVUELVE importe de ningún tipo, este se tiene
                que gestionar de forma autónoma por los medios disponibles del
                cliente. Indicando a continuación el método de devolución
                elegido para que quede registrado en el sistema.
              </p>
              <div className="form-group mt-5">
                <label>Método de Devolución:</label>
                <div
                  className="btn-group btn-group-toggle d-flex justify-content-center mt-2"
                  data-toggle="buttons"
                >
                  <button
                    type="button"
                    className={`btn btn-outline-primary ${devolutionMethod === "TPV" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "TPV" })}
                  >
                    <i className="fas fa-credit-card mr-2"></i>Tarjeta
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline-success ${devolutionMethod === "CASH" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "CASH" })}
                  >
                    <i className="fas fa-money-bill-wave mr-2"></i>Efectivo
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline-secondary ${devolutionMethod === "FREE" ? "active" : ""}`}
                    onClick={() => this.setState({ devolutionMethod: "FREE" })}
                  >
                    <i className="fas fa-gift mr-2"></i>Gratis
                  </button>
                </div>
              </div>
              <button
                disabled={!devolutionMethod}
                className="btn bg-success text-white mt-5 mr-3"
                onClick={this.generateCounterInvoice}
              >
                Confirmar Devolución
              </button>
              <button
                className="btn bg-danger text-white mt-5"
                onClick={this.resetProcess}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (confirmationStep === 2 && counterInvoiceData) {
      const itemName = getLockersName(counterInvoiceData.Items[0].item);

      return (
        <div className="row">
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <div className="lockerTicket mt-5" id="counterInvoicePrintable">
              <hr className="bg-vw-light" />
              <h5 className="lockTitle">
                <span className="text-vw-dark">TAQUILLA (DEVOLUCIÓN)</span>
              </h5>
              <h1 className="lockTitle">
                <span>{counterInvoiceData.Locker}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">TIPO</span>
              </h5>
              <h1 className="lockTitle">
                <span>{itemName}</span>
              </h1>

              <h5 className="lockTitle">
                <span className="text-vw-dark">PAGADO CON</span>
              </h5>
              <h1 className="lockTitle">
                <span>{counterInvoiceData.PaymentMethod}</span>
              </h1>

              <hr className="bg-vw-light" />
              <br />

              <h5 className="lockTitle">
                <span>{counterInvoiceData.Customer.Fullname}</span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">Terminal:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.Code.slice(0, -6)}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura Original:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.OriginalInvoice}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Factura Devolución:</span>
              </h5>
              <h5 className="lockTitle">
                <span>{counterInvoiceData.Code}</span>
              </h5>

              <h5 className="lockTitle">
                <span className="text-vw-dark">Fecha/Hora:</span>
              </h5>
              <h5 className="lockTitle">
                <span>
                  {new Date(counterInvoiceData.TimeStamp).toLocaleString()}
                </span>
              </h5>
              <br />

              <h5 className="lockTitle">
                <span className="text-vw-dark">PRODUCTOS DEVUELTOS</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>
                  {counterInvoiceData.Items[0].qty}x {itemName}
                </span>
                <span>{counterInvoiceData.Amount.toFixed(2)}€</span>
              </h5>
              <br />

              <h5 className="lockTitleJustify">
                <span>MONEDA:</span>
                <span>EUR</span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>BASE:</span>
                <span>
                  {this.getBase(counterInvoiceData.Amount).toFixed(2)}€
                </span>
              </h5>
              <h5 className="lockTitleJustify">
                <span>IVA:</span>
                <span>
                  {this.getIva(counterInvoiceData.Amount).toFixed(2)}€
                </span>
              </h5>

              <h5 className="lockTitle">
                <span>-----------------</span>
              </h5>

              <h5 className="lockTitleJustify">
                <span>TOTAL DEVUELTO:</span>
                <span>{counterInvoiceData.Amount.toFixed(2)}€</span>
              </h5>
              <br />
              <hr className="bg-vw-light" />
            </div>
          </div>
          <div className="col col-12 col-lg-6 ml-auto mr-auto">
            <p>¿Deseas imprimir la factura para entregársela al cliente?</p>
            <p>
              *Recuerda quedarte con la factura original si entregas la
              contrafactura
            </p>
            <div className="mt-5 text-center">
              <button
                className="btn bg-info text-white mt-5 mr-3"
                onClick={(e) =>
                  this.printLockerTicket(e, "counterInvoicePrintable")
                }
              >
                Imprimir Devolución
              </button>
              <button
                className="btn bg-secondary text-white mt-5"
                onClick={this.resetProcess}
              >
                Finalizar
              </button>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  prebookLocker(lockerKey, price) {
    const prebooking = {};

    this.setState({
      lockerSelected: lockerKey,
      stepBarStep: 3,
      lockerPrice: price,
    });

    prebooking.Customer = this.props.customer._id;
    prebooking.LockerSelected = lockerKey;
    prebooking.Zone = this.state.zoneSelected;
    prebooking.Accessibility = false;

    this.props
      .postPrebooking(prebooking)
      .then((answer) => {
        this.setState({
          prebooking: true,
          lockerAssigned: answer.response.answerPrebooking.LockerAssigned,
          lockerPin: answer.response.answerPrebooking.LockerPin,
          lockerMatricula: answer.response.answerPrebooking.LockerMatricula,
          lockerPhones: answer.response.answerPrebooking.LockerPhones,
        });

        this.startCountdown();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  bookLocker() {
    if (this.state.bookingInProgress) return;

    this.setState({ bookingInProgress: true });

    const { pda } = this.props;

    let salePetition = {};

    const currentDate = new Date();

    // Get the individual components of the date and time
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    // Create the formatted timestamp
    const timestamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    salePetition.TimeStamp = timestamp;
    salePetition.Amount = parseInt(this.state.lockerPrice);
    salePetition.Code = pda.Code;
    salePetition.PaymentMethod = "PDA";
    salePetition.WorkerSession = "000000";
    salePetition.Language = "ES";
    salePetition.RedsysCode = "";
    salePetition.Locker = this.state.lockerAssigned;
    salePetition.Phone = this.state.phoneValue;

    this.props
      .postPDAsale(salePetition)
      .then((answer) => {
        let bookingPetition = {};

        bookingPetition.LockerAssigned = this.state.lockerAssigned;
        bookingPetition.Phone = this.state.phoneValue;
        bookingPetition.Origin = "RP";

        this.setState({
          invoice: answer.response.toSaveSale.Code,
          time: `${day}-${month}-${year} ${hours}:${minutes}`,
        });

        this.props
          .postBooking(bookingPetition)
          .then((answer) => {
            clearInterval(this.countdownInterval);

            this.setState({
              booked: true,
              stepBarStep: 4,
              bookingInProgress: false,
            });
          })
          .catch((error) => {
            console.error(error);
            this.setState({ bookingInProgress: false });
          });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ bookingInProgress: false });
      });
  }

  resetProcess = () => {
    this.setState({
      choiceMade: 0,
      isTimeUp: false,
      zoneSelected: 0,
      lockerSelected: "",
      lockerAssigned: false,
      prebooking: false,
      stepBarStep: 1,
      booked: false,
      ticketInvoice: "",
      saleData: null,
      counterInvoiceData: null,
      fetchingSale: false,
      saleNotFound: false,
      confirmationStep: 0,
      devolutionMethod: null,
    });

    clearInterval(this.countdownInterval);
  };

  getBase(price) {
    const taxRate = 0.21;
    const base = price / (1 + taxRate);
    return base;
  }

  getIva(price) {
    const taxRate = 0.21;
    const base = this.getBase(price);
    const iva = price - base;
    return iva;
  }

  renderBlocked() {
    const { role } = this.props;
    const isAdmin = role === "ADMIN";

    return (
      <div className="ls-blocked-wrap">
        <div className="ls-blocked-card">
          <div className={`ls-blocked-icon ${isAdmin ? "admin" : "customer"}`}>
            <i className={isAdmin ? "fas fa-shield-alt" : "fas fa-lock"}></i>
          </div>
          <h2 className="ls-blocked-title">
            {isAdmin
              ? "Acceso Restringido"
              : "Acceso Exclusivo para Usuarios Operativos"}
          </h2>
          <p className="ls-blocked-subtitle">
            {isAdmin
              ? "Esta sección está destinada exclusivamente a usuarios Operativos. Los administradores no tienen acceso a la venta directa de taquillas. Utiliza el panel de administración para gestionar ventas."
              : "La venta de taquillas desde este módulo solo está disponible para cuentas de tipo Operativo. Tu cuenta actual no tiene acceso directo."}
          </p>

          {!isAdmin && (
            <>
              <div className="ls-steps-box">
                <h6>¿Cómo acceder al módulo de venta?</h6>
                <div className="ls-step-item">
                  <span className="ls-step-num">1</span>
                  <span className="ls-step-text">
                    Ve a la sección <strong>Usuarios &rarr; Operativos</strong> desde
                    el menú principal y crea un usuario Operativo asociado a tu
                    cuenta.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">2</span>
                  <span className="ls-step-text">
                    Cierra sesión con tu cuenta actual.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">3</span>
                  <span className="ls-step-text">
                    Inicia sesión con las credenciales del usuario Operativo que
                    acabas de crear.
                  </span>
                </div>
                <div className="ls-step-item">
                  <span className="ls-step-num">4</span>
                  <span className="ls-step-text">
                    Accede de nuevo a esta sección para empezar a realizar
                    ventas.
                  </span>
                </div>
              </div>
              <button
                className="ls-btn-cta"
                onClick={() => this.props.push("/my-pda-users")}
              >
                <i className="fas fa-users-cog"></i>
                Ir a Gestión de Usuarios Operativos
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { fullname, pda, role, type } = this.props;
    const { isTimeUp } = this.state;

    if (type !== "PDA") {
      return this.renderBlocked();
    }

    return (
      <div className="ls-sale-view">
        <div className="ls-sale-wrap">
          <div className="ls-sale-content">
            {this.state.choiceMade === 0 && (
              <div className="ls-section">
                <h2 className="ls-section-title">
                  ¿QUIERES VENDER O DEVOLVER UNA TAQUILLA?
                </h2>
                <div className="ls-choice-grid">{this.renderChoice()}</div>
              </div>
            )}
            {this.state.choiceMade === 1 && this.state.zoneSelected === 0 && (
              <div className="ls-section">
                <h2 className="ls-section-title">INDICA LA ZONA</h2>
                <div className="row justify-content-center">
                  {this.renderZones()}
                </div>
              </div>
            )}
            {this.state.zoneSelected !== 0 && !this.state.lockerSelected && (
              <div className="ls-section">
                <h2 className="ls-section-title">SELECCIONA UNA TAQUILLA</h2>
                <div className="row justify-content-center">
                  {this.renderLockers()}
                </div>
              </div>
            )}
            {this.state.zoneSelected !== 0 &&
              this.state.lockerSelected &&
              !this.state.booked && (
                <div className="ls-section">
                  <h2 className="ls-section-title">TELÉFONO DE RESPALDO</h2>
                  {this.state.prebooking ? (
                    <div className="row justify-content-center pt-2 pr-5 pl-5">
                      {this.renderPhone()}
                    </div>
                  ) : (
                    <div>
                      <LoadingProgress />
                      <h5 className="ct">Esperando Taquilla...</h5>
                    </div>
                  )}
                </div>
              )}
            {this.state.choiceMade === 2 && (
              <div className="ls-section">
                <h2 className="ls-section-title">DEVOLUCIÓN DE TAQUILLA</h2>
                <div className="row justify-content-center">
                  {this.renderDevolution()}
                </div>
              </div>
            )}
          </div>
          <div className="ls-action-bar">
            {!this.state.booked ? (
              <div className="ls-btn-row">
                {this.state.choiceMade === 1 && (
                  <>
                    <button
                      className="ls-btn-reset"
                      disabled={!this.state.zoneSelected}
                      onClick={() => this.resetProcess()}
                    >
                      <i className="fas fa-redo"></i>REINICIAR
                    </button>
                    <button
                      className="ls-btn-assign"
                      disabled={
                        !this.state.lockerAssigned ||
                        this.state.phoneValue.length < 6 ||
                        this.state.phoneDuplicate
                      }
                      onClick={() => this.bookLocker()}
                    >
                      <i className="fas fa-check-circle"></i>ASIGNAR
                    </button>
                  </>
                )}
              </div>
            ) : (
              <div className="ls-btn-row">
                <button
                  className="ls-btn-print"
                  disabled={
                    !this.state.lockerAssigned ||
                    this.state.phoneValue.length < 6
                  }
                  onClick={(e) => this.printLockerTicket(e, "printableTicket")}
                >
                  <i className="fas fa-print"></i>IMPRIMIR
                </button>
                <button
                  className="ls-btn-reset"
                  onClick={() => this.resetProcess()}
                >
                  <i className="fas fa-redo"></i>REINICIAR
                </button>
              </div>
            )}
            {this.state.choiceMade === 1 && (
              <StepBar step={this.state.stepBarStep} />
            )}
          </div>
          {this.state.booked && (
            <div className="col col-12 col-lg-8 ml-auto mr-auto">
              <Box title="Ticket">
                <div className="lockerTicket" id="printableTicket">
                  <hr className="bg-vw-light" />
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">TAQUILLA</span>
                  </h5>
                  <h1 className="lockTitle">
                    <span>{this.state.lockerMatricula}</span>
                  </h1>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">PIN</span>
                  </h5>
                  <h1 className="lockTitle">
                    <span>{this.state.lockerPin}</span>
                  </h1>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">TIPO</span>
                  </h5>
                  <h1 className="lockTitle">
                    <span>
                      {getLockersName(`LOCKER${this.state.lockerSelected}`)}
                    </span>
                  </h1>
                  <hr className="bg-vw-light" />
                  <br></br>
                  <h5 className="lockTitle">
                    <span>{this.state.customer}</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>{this.state.cif}</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>{this.state.address}</span>
                  </h5>
                  <br></br>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">Terminal:</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>{pda.Code}</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">Factura simplificada:</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>{this.state.invoice}</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">Fecha/Hora:</span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>{this.state.time}</span>
                  </h5>
                  <br></br>
                  <h5 className="lockTitle">
                    <span className="text-vw-dark">PRODUCTOS</span>
                  </h5>
                  <h5 className="lockTitleJustify">
                    <span>
                      1x {getLockersName(`LOCKER${this.state.lockerSelected}`)}
                    </span>
                    <span>{this.state.lockerPrice.toFixed(2)}€</span>
                  </h5>
                  <br></br>
                  <h5 className="lockTitleJustify">
                    <span>MONEDA:</span>
                    <span>EUR</span>
                  </h5>
                  <h5 className="lockTitleJustify">
                    <span>BASE:</span>
                    <span>
                      {this.getBase(this.state.lockerPrice).toFixed(2)}€
                    </span>
                  </h5>
                  <h5 className="lockTitleJustify">
                    <span>IVA:</span>
                    <span>
                      {this.getIva(this.state.lockerPrice).toFixed(2)}€
                    </span>
                  </h5>
                  <h5 className="lockTitle">
                    <span>-----------------</span>
                  </h5>
                  <h5 className="lockTitleJustify">
                    <span>TOTAL:</span>
                    <span>{this.state.lockerPrice.toFixed(2)}€</span>
                  </h5>
                  <br></br>
                  <hr className="bg-vw-light" />
                </div>
              </Box>
            </div>
          )}
          <div>
            <Modal isOpen={isTimeUp}>
              <ModalHeader>Tiempo de reserva agotado</ModalHeader>
              <ModalBody>
                Lo sentimos, pero no podemos reservar tu taquilla por más
                tiempo, otros usuarios deben poder acceder a ella. Vuelve a
                iniciar el proceso y finaliza la compra en el tiempo estipulado.
              </ModalBody>
              <ModalFooter>
                <Button
                  color="warning"
                  className="button-center"
                  onClick={this.handleRedirect}
                >
                  Volver al inicio
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customers.customer,
  matrixs: state.matrixs.matrixs,
  pda: state.pdas.pda,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category,
  fullname: state.auth.fullname,
  id: state.auth.id,
  form: state.form,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchPDACustomer: bindActionCreators(fetchPDACustomer, dispatch),
  postBooking: bindActionCreators(postBooking, dispatch),
  postPrebooking: bindActionCreators(postPrebooking, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
  postPDAsale: bindActionCreators(postPDAsale, dispatch),
  fetchSaleTicket: bindActionCreators(fetchSaleTicket, dispatch),
  postCounterInvoicePDASale: bindActionCreators(
    postCounterInvoicePDASale,
    dispatch,
  ),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerSaleView);
